// System Logs Vuex

import state from './systemLogStates.js'
import * as getters from './systemLogGetters.js'
import * as mutations from './systemLogMutations.js'
import * as actions from './systemLogActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
